<template>
  <v-app>
    <v-card class="mx-auto" color="#1b5e20">
      <v-layout>
        <v-app-bar
          app
          color="transparent"
          extended
          v-if="isHome"
          height="0px"
          shrink-on-scroll
          scroll-target="#scrolling-techniques-3"
          elevation="0"
        >
          <v-row no-gutters>
            <v-col cols="2" sm="2" md="2" class="hidden-sm-and-down">
              <v-card-text class="text-center">
                <img
                  :src="getImage('/' + setting.logo_path_url)"
                  height="30%"
                  width="30%"
                  contain
                />
                <v-avatar size="50"></v-avatar>
              </v-card-text>
            </v-col>
            <v-col cols="7" sm="7" md="7">
              <v-card>
                <v-autocomplete
                  class="mt-4 mx-auto hidden-sm-and-down"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  v-model="model"
                  chips
                  clearable
                  hide-details
                  hide-selected
                  item-text="title"
                  item-value="id"
                  label="Search for a coin..."
                  solo
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Search for your favorite
                        <strong>product</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <v-chip
                      v-bind="attr"
                      :input-value="selected"
                      color="blue-grey"
                      class="white--text"
                      v-on="on"
                    >
                      <span v-text="item.title"></span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-img
                        :src="getImage('/' + item.cover)"
                        :alt="item.name"
                        @click="productSelect(item)"
                      ></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                        @click="productSelect(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon @click="productSelect(item)">mdi-magnify</v-icon>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>
              </v-card>
              <v-card elevation="0" style="height: 10px" class="mx-auto hidden-sm-and-up">
                <v-text-field
                  label="search"
                  class="mt-5"
                  filled
                  append-icon="mdi-magnify"
                  dense
                  solo
                  flat
                  @click="setDialogComponent('search')"
                  icon
                  outlined
                  color="transparent"
                  elevation="0"
                >
                </v-text-field>
              </v-card>
            </v-col>
            <v-col cols="0.5" sm="0.5" md="0.5">
              <v-card-text class="text-center">
                <v-btn
                  icon
                  @click="setDialogComponent('cart')"
                  color="#1B5E20"
                  elevation="0"
                  style="background-color: white"
                >
                  <v-badge color="orange" overlap v-if="countCart != 0">
                    <template v-slot:badge v-if="countCart > 0">
                      <span>{{ countCart }} </span>
                    </template>
                    <v-icon>mdi-cart</v-icon>
                  </v-badge>
                  <v-icon v-if="countCart == 0">mdi-cart</v-icon>
                </v-btn>
              </v-card-text>
            </v-col>
            <v-col cols="0.5" sm="0.5" md="0.5" class="hidden-sm-and-down">
              <v-card-text class="text-center" v-if="!guest">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar color="#1b5e20" size="50">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        :src="getImage('/' + user.avatar)"
                      ></v-img>
                    </v-avatar>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="item in icons"
                      :key="item.title"
                      :to="item.route"
                      link
                    >
                      <v-list-item-icon>
                        <v-icon color="#1b5e20" size="36px">{{ item.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title class="black--text">{{
                          item.title
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-text class="text-center">
                      <v-btn
                        @click="logout"
                        rounded
                        color="#1b5e20"
                        outlined
                        elevation="5"
                      >
                        <v-icon left>mdi-lock</v-icon>
                        Logout
                      </v-btn>
                    </v-card-text>
                  </v-list>
                </v-menu>
              </v-card-text>
              <v-card-text class="text-center">
                <v-menu offset-y v-if="guest">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      rounded
                      color="#1b5e20"
                      elevation="0"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-card-text class="text-center">
                      <v-btn
                        @click="setDialogComponent('login')"
                        rounded
                        color="#1b5e20"
                        outlined
                        elevation="5"
                        class="mt-2"
                      >
                        <v-title class="black--text">Login</v-title>
                      </v-btn>
                    </v-card-text>
                    <v-card-text class="text-center">
                      <v-btn
                        @click="setDialogComponent('register')"
                        rounded
                        color="#1b5e20"
                        outlined
                        elevation="5"
                        class="mt-2"
                      >
                        <v-title class="black--text">Register</v-title>
                      </v-btn>
                    </v-card-text>
                  </v-list>
                </v-menu>
              </v-card-text>
            </v-col>
            <v-col cols="0.5" sm="0.5" md="0.5" class="hidden-sm-and-down">
              <v-card-text class="text-center" v-if="guest"> </v-card-text>
            </v-col>
            <v-col cols="1" sm="1" md="1" class="hidden-md-and-up">
              <v-card-text class="text-center">
                <v-app-bar-nav-icon
                  @click.stop="drawer = !drawer"
                  color="#1b5e20"
                  elevation="0"
                  style="background-color: white"
                >
                </v-app-bar-nav-icon>
              </v-card-text>
            </v-col>
          </v-row>
        </v-app-bar>

        <v-app-bar app color="#1b5e20" dark v-else elevation="0">
          <v-btn
            icon
            @click.stop="$router.go(-1)"
            color="white"
            elevation="0"
            class="white--text"
            large
          >
            <v-icon>mdi-arrow-left-circle</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="setDialogComponent('cart')"
            color="white"
            elevation="0"
            class="white--text"
          >
            <v-badge color="orange" overlap>
              <template v-slot:badge v-if="countCart > 0">
                <span>{{ countCart }} </span>
              </template>
              <v-icon color="white" elevation="0" class="white--text" large
                >mdi-cart</v-icon
              >
            </v-badge>
          </v-btn>
        </v-app-bar>
      </v-layout>
    </v-card>
    <v-card class="hidden-md-and-up">
      <v-navigation-drawer app v-model="drawer" color="white" width="100%">
        <v-toolbar color="#1b5e20" elevation="0">
          <v-btn
            icon
            dark
            @click.stop="drawer = !drawer"
            color="white"
            elevation="0"
            class="white--text"
          >
            <v-icon>mdi-arrow-left-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-col
          cols="12"
          md="6"
          class="rounded-bl-xl"
          v-if="guest"
          style="background-color: #1b5e20"
        >
          <div style="text-align: center">
            <v-card-text class="white--text">
              <h3 class="text-center">Welcome to Indorobotika</h3>
              <h6 class="text-center">
                Indorobotika as a shopping platform and internet of things service
              </h6>
            </v-card-text>
            <div class="text-center">
              <v-card-text class="text-center" v-if="guest">
                <v-btn
                  icon
                  @click="setDialogComponent('register')"
                  rounded
                  color="white"
                  outlined
                  elevation="5"
                >
                  <v-icon>mdi-account-plus</v-icon>
                </v-btn>
                <v-list-item-title class="white--text">Register</v-list-item-title>
              </v-card-text>

              <v-card-text class="text-center" v-if="guest">
                <v-btn
                  icon
                  @click="setDialogComponent('login')"
                  rounded
                  color="white"
                  outlined
                  elevation="5"
                >
                  <v-icon>mdi-login</v-icon>
                </v-btn>
                <v-list-item-title class="white--text">Login</v-list-item-title>
              </v-card-text>

              <v-card-text class="text-center" v-if="guest">
                <v-btn
                  icon
                  @click="setDialogComponent('forgot')"
                  rounded
                  color="white"
                  outlined
                  elevation="5"
                >
                  <v-icon>mdi-lock-reset</v-icon>
                </v-btn>
                <v-list-item-title class="white--text">Forgot Password</v-list-item-title>
              </v-card-text>
            </div>
          </div>
        </v-col>
        <v-card-text class="text-center" v-if="!guest" style="height: 70%">
          <v-avatar v-if="!guest" color="#1b5e20" size="100">
            <v-img
              v-bind="attrs"
              v-on="on"
              v-if="!guest"
              :src="getImage('/' + user.avatar)"
            ></v-img>
          </v-avatar>
        </v-card-text>

        <!-- v-if="!guest" -->
        <!-- <v-card-text class="text-left" v-if="!guest">
          <v-list-item v-for="item in icons" :key="item.title" :to="item.route" link>
            <v-list-item-icon>
              <v-icon color="#1b5e20" >{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="black--text">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-text> -->

        <template>
          <v-card-text class="text-center" v-if="!guest">
            <v-btn
              @click="logout"
              style="background-color: red"
              rounded
              class="white--text"
            >
              <v-icon>mdi-lock</v-icon>
              Logout
            </v-btn>
          </v-card-text>
          <v-footer class="hidden-md-and-up">
            <v-row>
              <v-card class="flex" flat tile>
                <v-card-text class="text-center">
                  <v-btn
                    v-for="menu in menus"
                    :key="menu"
                    class="mx-4"
                    dark
                    icon
                    :href="menu.link"
                    target="_blank"
                  >
                    <v-icon size="36px" :color="menu.color">
                      {{ menu.icon }}
                    </v-icon>
                  </v-btn>
                </v-card-text>

                <v-card-text class="text-center black--text">
                  <strong>
                    &copy; {{ new Date().getFullYear() }} — indorobotika
                    {{ version }}</strong
                  >
                </v-card-text>
              </v-card>
            </v-row>
          </v-footer>
        </template>
      </v-navigation-drawer>
    </v-card>

    <alert />

    <keep-alive>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="scale-transition">
        <component :is="currentComponent" @closed="setDialogStatus"></component>
      </v-dialog>
    </keep-alive>

    <!-- Sizes your content based upon application components -->

    <v-content style="padding: 0px 0px 0px" class="hidden-sm-and-down">
      <!-- Provides the application the proper gutter -->
      <br />
      <br />

      <v-slide-y-transition mode="out-in">
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-slide-y-transition>

      <!-- <v-container fluid color="blue"> </v-container> -->
    </v-content>
    <v-content style="padding: 0px 0px 0px" class="hidden-md-and-up">
      <!-- Provides the application the proper gutter -->

      <v-slide-y-transition mode="out-in">
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-slide-y-transition>
      <br />
      <br />
      <br />
      <!-- <v-container fluid color="blue"> </v-container> -->
    </v-content>

    <v-layout class="overflow-visible">
      <v-bottom-navigation
        v-model="value"
        app
        class="hidden-md-and-up"
        elevation="0"
        style="background-color: white"
      >
        <v-card-actions class="justify-center">
          <v-list-item v-for="item in icons" :key="item.title" :to="item.route" link>
            <v-icon color="#1B5E20" size="40"
              >{{ item.icon }}
              <v-tooltip activator="parent" location="top">{{ item.title }}</v-tooltip>
            </v-icon>
          </v-list-item>
        </v-card-actions>
      </v-bottom-navigation>
    </v-layout>

    <v-footer class="bg-#1B5E20 hidden-sm-and-down">
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-container class="text-justify">
              {{ information }}
            </v-container>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="4"
            ><v-container class="text-left"
              ><span class="mdi mdi-copyright"></span> indorobotika
              {{ new Date().getFullYear() }}
            </v-container>
          </v-col>
          <v-col cols="4" sm="4" md="4" class="text-center">
            <v-container class="text-center">
              <v-btn
                color="#1b5e20"
                v-for="menu in menus"
                :key="menu"
                class="mx-4"
                dark
                icon
                :href="menu.link"
                target="_blank"
              >
                <v-icon size="36px" :color="menu.color">
                  {{ menu.icon }}
                </v-icon>
              </v-btn>
            </v-container>
          </v-col>
          <v-col cols="4" sm="4" md="4" class="text-right">
            <v-container class="text-right">
              <v-btn
                elevation="0"
                variant="text"
                v-for="link in links"
                :key="link"
                class="mx-2"
                :to="link.route"
              >
                {{ link.title }}
              </v-btn></v-container
            ></v-col
          >
        </v-row>
      </v-container>
    </v-footer>

    <div v-if="guest">
      <v-dialog v-model="dialogVersion" max-width="400">
        <v-col class="text-right">
          <v-btn
            @click="dialogVersion = false"
            icon
            rounded
            color="white"
            outlined
            elevation="5"
            large
            class="mx-4 warning"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-card class="mx-auto" color="warning" dark max-width="400">
          <v-card-title>
            <v-list-item-avatar color="grey darken-3">
              <v-img
                class="elevation-6"
                alt=""
                src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
              >
              </v-img>
            </v-list-item-avatar>
          </v-card-title>

          <v-card-text class="text-h5 font-weight-bold">
            "Mohon hapus cache / history penjelajahan browser atau update android anda
            untuk mendapatkan pembaharuan aplikasi!"
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.x/dist/vue.js"></script>
<script src="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.2.4/jspdf.plugin.autotable.min.js"></script>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Alert: () => import(/* webpackChunkName: "alert" */ "@/components/Alert.vue"),
    Search: () => import(/* webpackChunkName: "search" */ "@/components/Search.vue"),
    Login: () => import(/* webpackChunkName: "login" */ "@/components/Login.vue"),
    Register: () =>
      import(/* webpackChunkName: "register" */ "@/components/Register.vue"),
    Cart: () => import(/* webpackChunkName: "cart" */ "@/components/Cart.vue"),
    Forgot: () => import(/* webpackChunkName: "forgot" */ "@/components/Forgot.vue"),
    ProductItem: () =>
      import(/* webpackChunkName: "product-item" */ "@/components/ProductItem.vue"),
  },
  data: () => ({
    drawer: false,
    menus: [
      { icon: "mdi-whatsapp", link: "https://wa.link/jggpi1", color: "#1b5e20" },
      {
        icon: "mdi-instagram",
        link: "https://www.instagram.com/indorobotika/",
        color: "red",
      },
    ],
    icons: [
      { title: "Home", icon: "mdi-home", route: "/" },
      // {
      //   title: "IOT Service",
      //   icon: "mdi-radio-tower",
      //   route: "/iot-view",
      // },
      {
        title: "My Orders",
        icon: "mdi-shopping",
        route: "/my-order",
        auth: true,
      },
      {
        title: "Account",
        icon: "mdi-account-cog",
        route: "/my-account",
        auth: true,
      },
    ],
    padless: true,
    variant: "fixed",
    keyword: "",
    products: [],
    isLoading: false,
    items: [],
    search: null,
    type_information: "",
    information: "",
    links: [{ title: "Privacy Policy", route: "/about" }],
    dialogVersion: false,
    version: "",
  }),
  methods: {
    ...mapActions({
      setDialogStatus: "dialog/setStatus",
      setDialogComponent: "dialog/setComponent",
      setAuth: "auth/set",
      setAlert: "alert/set",
      setSetting: "setting/set",
    }),

    productSelect(item) {
      let path = "/product/" + item.slug;
      this.$router.push(path);
      this.items = [];
    },

    logout() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/logout", {}, config)
        .then(() => {
          this.setAuth({}); // kosongkan auth ketika logout
          this.setAlert({
            status: true,
            color: "success",
            text: "Logout successfully",
          });
        })
        .catch((error) => {
          let { data } = error.response;
          this.setAlert({
            status: true,
            color: "error",
            text: data.message,
          });
        });
    },
  },
  computed: {
    isHome() {
      return this.$route.path === "/";
    },
    ...mapGetters({
      countCart: "cart/count",
      guest: "auth/guest",
      user: "auth/user",
      dialogStatus: "dialog/status",
      currentComponent: "dialog/component",
      setting: "setting/setting",
      height() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return 220;
          case "sm":
            return 400;
          case "md":
            return 500;
          case "lg":
            return 600;
          case "xl":
            return 800;
        }
      },
    }),
    dialog: {
      get() {
        return this.dialogStatus;
      },
      set(value) {
        this.setDialogStatus(value);
      },
    },
    localAttrs() {
      const attrs = {};
      attrs[this.variant] = true;

      return attrs;
    },
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;

      this.isLoading = true;

      this.axios
        .get("/ecommerce-products/search-all")
        .then((response) => {
          let { data } = response.data;
          this.items = data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  created() {
    this.axios
      .get("/information")
      .then((response) => {
        this.type_information = response.data.data_type;
        this.information = response.data.data_infromation;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    let url = "/store-setting-eccomerce";
    this.axios
      .get(url)
      .then((response) => {
        let { data } = response.data;
        this.setSetting(data);
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/information")
      .then((response) => {
        this.type_information = response.data.data_type;
        this.information = response.data.data_infromation;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/version")
      .then((response) => {
        let { data_app } = response.data;
        this.version = data_app;
        if (this.version == "1.0.2") {
          this.dialogVersion = false;
        } else {
          this.dialogVersion = true;
        }
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });
  },
};
</script>
